// ABOUTME: Pagination controls for query results with page size selector and navigation buttons
// ABOUTME: Handles page size changes and previous/next page navigation

import React from 'react';
import { QueryMetadata } from './types';

interface PaginationControlsProps {
  pageSize: number;
  currentPage: number;
  metadata: QueryMetadata | null;
  onPageSizeChange: (size: number) => void;
  onNextPage: () => void;
  onPrevPage: () => void;
  disabled?: boolean;
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  pageSize,
  currentPage,
  metadata,
  onPageSizeChange,
  onNextPage,
  onPrevPage,
  disabled = false,
}) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1rem',
      borderBottom: '1px solid var(--border-color)',
      backgroundColor: 'var(--bg-darker)',
      gap: '1rem'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ fontSize: '0.875rem', color: 'var(--text-medium)', whiteSpace: 'nowrap' }}>
          Show:
        </span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          disabled={disabled}
          style={{
            padding: '0.375rem 2rem 0.375rem 0.75rem',
            fontSize: '0.875rem',
            border: '1px solid var(--border-color)',
            borderRadius: '0.375rem',
            backgroundColor: 'var(--bg-light)',
            color: 'var(--text-dark)',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <span style={{ fontSize: '0.875rem', color: 'var(--text-medium)', whiteSpace: 'nowrap' }}>
          per page
        </span>
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <span style={{ fontSize: '0.875rem', color: 'var(--text-medium)' }}>
          Page {currentPage}
          {metadata && (
            <>
              <span style={{ marginLeft: '0.5rem' }}>
                • {metadata.count} result{metadata.count !== 1 ? 's' : ''}
              </span>
              {metadata.hasMore && (
                <span style={{ color: 'var(--primary-color)', marginLeft: '0.5rem', fontWeight: 600 }}>
                  • More available
                </span>
              )}
            </>
          )}
        </span>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            onClick={onPrevPage}
            disabled={currentPage === 1 || disabled}
            style={{
              padding: '0.375rem 0.75rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              backgroundColor: currentPage === 1 ? '#6b7280' : 'var(--primary-color)',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: (currentPage === 1 || disabled) ? 'not-allowed' : 'pointer',
              opacity: (currentPage === 1 || disabled) ? 0.6 : 1,
              transition: 'opacity 0.2s'
            }}
            onMouseEnter={(e) => {
              if (currentPage !== 1 && !disabled) {
                e.currentTarget.style.opacity = '0.9';
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== 1 && !disabled) {
                e.currentTarget.style.opacity = '1';
              }
            }}
          >
            Previous
          </button>
          <button
            onClick={onNextPage}
            disabled={!metadata?.hasMore || disabled}
            style={{
              padding: '0.375rem 0.75rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              backgroundColor: !metadata?.hasMore ? '#6b7280' : 'var(--primary-color)',
              color: 'white',
              border: 'none',
              borderRadius: '0.375rem',
              cursor: (!metadata?.hasMore || disabled) ? 'not-allowed' : 'pointer',
              opacity: (!metadata?.hasMore || disabled) ? 0.6 : 1,
              transition: 'opacity 0.2s'
            }}
            onMouseEnter={(e) => {
              if (metadata?.hasMore && !disabled) {
                e.currentTarget.style.opacity = '0.9';
              }
            }}
            onMouseLeave={(e) => {
              if (metadata?.hasMore && !disabled) {
                e.currentTarget.style.opacity = '1';
              }
            }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};












